/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState,useRef } from 'react'
import { APIEndpoint, DFPAPIEndpoint } from '../../../../utils/axios';
import { Modal,EditModal,Loading} from '../../../../common';
import {defaultPageLimitGrid } from '../../../../utils/configs';
import {formatDateByTimezone,getCultureFromLs,getTimeZoneAbbreviation, storageUtil} from '../../../../utils/commonFunctions';
import { FaSearch } from "react-icons/fa";
import moment from 'moment-timezone';
import LoadingIn from '../../../../assets/loadingIn.gif';
import usePermissions from '../../../../utils/userPermissions';
import { IoReloadCircleSharp } from "react-icons/io5";
import { FaFlag } from "react-icons/fa";
import { FaLock } from "react-icons/fa";
import SectorListing from './sectorListing';
import SectorsEditIsolate from './sectorsEditIsolate';
import { useNavigate } from "react-router-dom";


export const  EditContainer=({id,instance,delOffld,setSorting,setNavigateInstanceId, dfpCommit, setEditAction,editAction,navigateInstanceId,scrollContainer,setEditDetailsContainer,sorting,eventLogs, inventoryDetails, stateSynced})=> {

const sType = localStorage.getItem('sType');
const DOMAIN = (sType === 'dfp' ? DFPAPIEndpoint : APIEndpoint);
const [state,setState]=useState({ignoreWarningCheck:false});
const [modalFormStatusObj, setModalFormStatusObj] = useState({ text: '' });
const [stores,setStores]=useState(()=>{
  const respStor=sessionStorage.getItem('storL');
  return respStor?JSON.parse(respStor):[]
});
const [editorInstance,setEditorInstance]=useState(instance);
const[sectorListing,setSectorListing]=useState([]);
const [editDetails,setEditDetails]=useState({});
const [optionsSector, setOptionsSector] = useState([{key: 0, label: 'Select Sector', value: ''}]);
const [optionsWarehouse, setOptionsWarehouse] = useState([{key: 0, label: 'Select Warehouse', label2: 'Select Warehouse',value: ''}]);
  const [buttonStatus,setButtonStatus]=useState(false);

const [employees,setEmployees]=useState(()=>{
  const respEm=sessionStorage.getItem('emple');
  return respEm?JSON.parse(respEm):[]
});
const [committing,setCommitting] = useState(false);
const [loading, setLoading] = useState(true);
const [page, setPage] = useState(1);
  const [isDropDownOpen,setIsDropdownOpen]=useState(false);
  const [ModalContHeight,setModalContHeight]=useState({height:'auto'});
const [loadingEditSectors, setLoadingEditSectors] = useState(true);
const [sectors,setSectors]=useState([]);
const [employee,setEmployee]=useState([]);
const [flights,setFilghts]=useState("");
const [editedSectors,setEditedSectors]=useState([]);
const [EditFieldsCess, setEditFieldsCess] = useState([]);
const [loadSectorListing, setLoadSectorListing] = useState(false);
const [modalCustomButtons,setModalCustomButtons]=useState([]);
const [ modalTitle, setModalTitle ] = useState('');
const [searchKeyOrders,setSearchKeyOrders]=useState("");
const [filterSectors,setFilterSectors]=useState(false);
const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
const [actionStatus,setActionStatus]=useState({action:'',status:""});
const { hasPermission: createUplifts } = usePermissions('create', 'orn:Store:ManageUplift');
let updatedEditFields = [];

const flagItem=useRef(null);
const containerRef = useRef();

  const culture = getCultureFromLs();
  const timeZoneLabel = culture?.timezone ? getTimeZoneAbbreviation(culture.timezone) : 'local time';

  const AddFormFields = [
    {label: 'Warehouse', attribute: 'warehouse', type: 'selectSearch2', disabled: false, options: optionsWarehouse, required: true },
    {label: 'Sector', attribute: 'sector', type: 'selectSearch2', disabled: false, options: optionsSector, required: true },
    {label:  `Flight Date *(in ${timeZoneLabel})`, attribute: 'flightDate', type: 'date', disabled: false, required: true},
  ];

useEffect(() => {
  const updateHeight = () => {
    const availableHeight = window.innerHeight * 0.733;
    if (containerRef.current) {
      containerRef.current.style.maxHeight = `${availableHeight}px`;
    }
  };

  updateHeight();
  window.addEventListener('resize', updateHeight);

  return () => {
    window.removeEventListener('resize', updateHeight);
  };
}, []);

  useEffect(() => {
    if(isDropDownOpen){
      setModalContHeight({height:'35vh'})
    }else{
      setModalContHeight({height:'auto'})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [isDropDownOpen]); 

useEffect(() => {
 if(employees.length ){
sessionStorage.setItem('emple',JSON.stringify(employees))
 }
 if(stores.length){
sessionStorage.setItem('storL',JSON.stringify(stores))

 }
}, [employees,stores])

useEffect(() => {
  if(actionStatus.action.length ){
    const tOut=setTimeout(() => {
    setActionStatus({action:'',status:''});
    }, 4350);
    return()=>clearTimeout(tOut);
  }
 }, [actionStatus])


useEffect(() => {
  if (id) {
    if(!employees?.length){
      fetchEmployees();
    }
    if(!stores.length){
      fetchStores();
    }
    fetchEditDocument();
  }
}, [id,instance]);

useEffect(() => {
  if (instance) {
    setEditorInstance(instance)
  }
}, [instance]);

useEffect(() => {
if(id){
  fetchSectorLists();
}
}, [editAction,id,instance]);

useEffect(() => {
  if(state?.selected && state.selected?.action==='findSectors'&& !filterSectors && !searchKeyOrders.length){
    if(flights||!employee.includes(null)||!sectors.includes(null)){
    sectorSearchFilters(page);
    }else{     
        fetchSectorLists();
    }
  }
}, [state,page,filterSectors,searchKeyOrders]);

useEffect(() => {
  if (searchKeyOrders.length||filterSectors) {
    sectorSearchFilters(page);
  }
}, [ searchKeyOrders,filterSectors, page]);

useEffect(() => {
  const timer = setTimeout(() => {
    if ((!editDetails || !editDetails.sectors?.length) && loadingEditSectors) {
      setLoadingEditSectors(false);
    }
  }, 5000);

  if (editDetails && editDetails.sectors && editDetails.sectors?.length) {
    setLoadingEditSectors(false);
  }

  return () => clearTimeout(timer);
}, [editDetails, loadingEditSectors]);

useEffect(() => {
  if(state?.selected?.action === 'commitInstance'){
    setModalCustomButtons([
      {
        label: committing ? 'Committing...' : 'Proceed',
        attribute:'button',
        type:"button",
        disabled: committing,
        className:'submit-button',
        action:(state)=>onEnableDisableAction(state)
      }
    ]);
  }
}, [committing]);

  const handleContainerClick = (e) => {
    if(flagItem.current && !flagItem.current.contains(e.target)) {
      setIsOpen(false);
      scrollContainer(false);
    }
  };

  useEffect(() => {
  
    document.addEventListener('mousedown', handleContainerClick);
    return () => {
      document.removeEventListener('mousedown', handleContainerClick);
    };
  }, []);

  const sectorSearchFilters=(pageSearch=null)=>{
    let filtersSec=[];
    const filterData={
      page: pageSearch,
      limit: defaultPageLimitGrid,
      ...(searchKeyOrders?.trim() && { searchParam: searchKeyOrders })
  }
const getSearchParams=(srchArr)=>{
if(srchArr.length> 0 && !srchArr.includes(null)){
  return Number(srchArr[0].value)
}
return null;
}

const filterConditions = [
  {condition:"isolate",filter:{
    key: 'isolateId',
    value: id,
    condition: 'NotEquals'
  }},
  {condition:"state",filter:{
    key: "state",
    value: [
        "open",
        "locked"
    ]
  }},
  { condition: employee, filter:  {
key: "employeeId",
value: getSearchParams(employee)
} },
  { condition: sectors, filter:   {
    key: "storeId",
    value:getSearchParams(sectors)
}, },
  { condition: flights, filter: {
    key: "flightDate",
    value:(flights && typeof flights==='object')? formatDateByTimezone(new Date(flights),true):null
} }
]
filterConditions.forEach(({ condition, filter }) => {
  if(filter.value && filter.value!=='Invalid date'){
    filtersSec.push(filter);
  }
  }
);
filterData.filters = filtersSec;
fetchSectorLists(filterData);

  }

const handleReset = () => {

  let timerId = setTimeout(() => {
    clearTimeout(timerId);
    setModalFormStatusObj({ text: '' })
    setState((_prev) => {
      return { ..._prev, selected: false,ignoreWarningCheck:false}
    });

  }, 3500)
}

const sectorDetails={
  sectors,setSectors,
employee,setEmployee,
editAction,page,setPage,
flights,setFilghts,loading,setLoading,
searchKeyOrders,setSearchKeyOrders,setFilterSectors,setSectorListing
}

  const onCloseModal = () => {
    setModalFormStatusObj({ text: '' });
    setState((_prev) => {
      return { ..._prev, selected: false }
    });
    setButtonStatus(false);
  }

const saveEdits=async(e,alt=null,updateObj=null)=>{
setLoading(true);
if(alt==='saveChanges' && !updateObj){
if(sorting && editedSectors.length){
     const payload={
    isolateId: id,
    documentId: editDetails?.id,
    edits: [
        {
            name: "ReorderSectors",
            params: {
                order:editedSectors?.map(fl=>fl.id)
            }
        }
    ]
}
try {

  const res = await APIEndpoint.post(`sandboxing/containerIsolates/editDocument/edits`,payload);
if(res){
setActionStatus({action:'Save Changes',status:'Saved pending changes'})
setEditAction(prev=>!prev);
setSorting(false);
setLoading(false);
sessionStorage.removeItem('SectorEdited');
return res;
}

} catch (error) {
  setLoading(false);
}
  }else{
setLoading(false);
  }
}
else{
  const payload={
    isolateId: id,
    documentId: editDetails?.id,
    edits:[
      {
          name: "RefreshUplifts",
          params: {
              target: {
                  id: updateObj.id,
                  key: updateObj.key,
                  name: updateObj.name
              }
          }
      }
  ]
}
try {

  const res = await APIEndpoint.post(`sandboxing/containerIsolates/editDocument/edits`,payload);
if(res){
setActionStatus({action:'Refresh Uplifts',status:'Uplifts refreshed'})
setLoading(false);

return res;
}

} catch (error) {

}
}


}


const fetchStores=async()=>{
  if(stores.length)return;
  try {
    const respStore = await DOMAIN.get('stores');
    if (respStore.result.length > 0) {
        const options = [];
        respStore.result.filter( (fieldValue, index) => {
          options.push({key: index+1, label: `${fieldValue.value} (${fieldValue.originName}-${fieldValue.destinationName})`, value: `${fieldValue.id}`});
          return fieldValue;
        });
        setStores(options);
    }

  } catch (error) {

  }
}

const attachSector=async(sectorId)=>{
  const payload={
    isolateId: id,
    sectorId
}
  try {
    const resAttach = await DOMAIN.post('sandboxing/containerIsolates/isolatedSectors/attach',payload);
  if(resAttach.sector){
    setModalFormStatusObj({text:"Sector Attached to Instance.You can attach more or close this dialog"})
    setEditAction(prev=>!prev);
  }
  else{
  }
  } catch (error) {
    const errResp=JSON.parse(error.message);
    setModalFormStatusObj({text:errResp.data?.message})
    handleReset();
  }
}

const fetchEditDocument=async(act=null)=>{
  setLoading(true);
  const payload={
    "isolateId": id
}

  try {
    const respEditDoc = await DOMAIN.post('sandboxing/containerIsolates/getEditDocument',payload);

    if (respEditDoc && respEditDoc.editDocument) {
      setLoading(false);
      if(act && act==='touch'){
        setActionStatus({action:'Touch',status:'Success'})
      }
        setEditDetails(respEditDoc.editDocument);
        setEditDetailsContainer(respEditDoc.editDocument);
        return respEditDoc.editDocument;
    }
    else{


    setLoading(false);

    }
  } catch (error) {

  }
}
const fetchEmployees=async()=>{
if(employees.length)return;
  try {
    const respEmp = await DOMAIN.get(`sandboxing/employees?includeAdmin=yes`);
    if (respEmp.result.length > 0) {
        const options = [];
        respEmp.result.filter( (fieldValue, index) => {
          options.push({key: index+1, label: `${fieldValue.employeeName} (${fieldValue.employeeCode})`, value: `${fieldValue.employeeId}`});
          return fieldValue;
        });
        setEmployees(options);
    }
    else{


    }
  } catch (error) {

  }
}

  const  fetchSectorLists=async(fil=null)=>{
    let filterData;
    if(!fil){
  filterData={
      page: page,
      limit: defaultPageLimitGrid,
      filters: [
          {
              key: 'isolateId',
              value: id,
              condition: 'NotEquals'
          },
          {
              key: "state",
              value: [
                  "open",
                  "locked"
              ]
          }
      ],
      searchParam: searchKeyOrders
  }
    }else{

      filterData=fil
    }
    if ((searchKeyOrders && page===1)||page===1) {
      setSectorListing([]);
  }
  try {
    setLoadSectorListing(true);
    const res = await APIEndpoint.post('sandboxing/containerIsolates/isolatedSectors/list', filterData);
    if(res && res.items && res.items.length ){
      if(searchKeyOrders){
        setSectorListing((_) => [...res.items, ..._]);
      }else{
        setSectorListing((_)=>[..._,...res.items]);
      }
    }
    setLoadSectorListing(false);
  } catch (error) {
    setLoadSectorListing(false);
  }
  };

const onClose = () => {
  setCommitting(false);
  setModalFormStatusObj({ text: '' });
  setActionStatus({action:'Commit Instance',status:'Operation cancelled by user'})
  setState((_prev) => ({
    ..._prev,
    selected: false,
    ignoreWarningCheck:false
  }));
}

  const toUpliftAddNavigate = (updatedid) => {
 
    const { fltDate, sector, warehouse, sectorId } = state.selected;
    if (optionsSector.length > 1) {
      const effectiveFlightDate = updatedid?.flightDate || fltDate;
      const dateid = effectiveFlightDate ? moment(effectiveFlightDate).format() : null;

      const sectorData = optionsSector.find(
        (data) => Number(data.value) === (sector ?? updatedid?.sector)
      );
      if (sectorData && dateid) {
        const wh = updatedid?.warehouse ?? warehouse;
        const sct = updatedid?.sector ?? sector;
        const navState = {
            invDetails:{edtId: editDetails?.id, sectId: sectorId, wh, sct, effectiveFlightDate},
            stateSynced: stateSynced || null
          };

        storageUtil.set('SALES_SYNC_NAV', navState, 'session');
          
        navigate(
          'inventory/editor/' + wh + '/' + sct + '/' + dateid,
          { state: { sectorName: sectorData.label ?? "", mode: 'fromSalesEditor', stateSynced: navState.stateSynced, invDetails: navState?.invDetails }}
        );
      }
    }
  }

  const onEditSubmit = async (e, updated) => {
    setModalFormStatusObj({ text: '' });

    const effectiveWarehouse = updated?.warehouse ?? state.selected.warehouse;
    const effectiveSector = updated?.sector ?? state.selected.sector;
    const effectiveFlightDate = updated?.flightDate ?? state.selected.flightDate;

    if (effectiveWarehouse != null && effectiveSector != null && effectiveFlightDate) {
      toUpliftAddNavigate(updated);
    } else {
      setModalFormStatusObj({ error: 'Please provide all the required fields' });
    }
  };

const onFieldChangeHandler = (e, updated) => {
  setModalFormStatusObj({ text: '' });

  setState(prev => ({
    ...prev,
    selected: {
      ...prev.selected,
      ...updated 
    }
  }));

  if ((!updated?.warehouse && !state?.selected?.warehouse )|| (!updated?.sector && !state?.selected?.sector) || (!updated.flightDate && !state?.selected?.flightDate)) {
    setButtonStatus(true);
  } else {
    setButtonStatus(false);
  }

  if (updated.warehouse) {
    fetchSectors(Number(updated.warehouse));
  }
};

 const onEnableDisableAction = async () => {

  setCommitting(true);

  const payload = {
    isolateId: editorInstance?.id,
    documentId: editDetails.id,
    ...(state.ignoreWarningCheck && { ignoreWarnings: true })
  };

  try {
    const res = await APIEndpoint.post('sandboxing/containerIsolates/commit', payload);

    if(res.commitResult && res.commitResult.status!=='failed' && !res.commitResult.canForceCommit){
      setEditAction(prev=>!prev);
      setActionStatus({action:'Commit Instance',status:'Success'})
      setModalFormStatusObj({ text: res.commitResult.status.charAt(0).toUpperCase()+ res.commitResult.status.slice(1) });
      handleReset();
    }

    else if(res.commitResult && res.commitResult.canForceCommit && res.commitResult.status==='failed'){
      setModalFormStatusObj({ error: 'Failed to commit instance.' });
      setState((prev)=>({...prev,selected:{...prev.selected,action:"forceCommit",dataWarnings:res.commitResult?.validationResult.documentErrors}}))
    }

    else if(res.commitResult && !res.commitResult.canForceCommit && res.commitResult.status==='failed'){
      setState((prev)=>({...prev,selected:{...prev.selected,action:"noForceCommit",dataWarnings:res.commitResult?.validationResult.documentErrors}}))
      setModalFormStatusObj({ error: 'Failed to commit instance.' });
    }

  } catch (error) {
    setModalFormStatusObj({ error:error.message });
  }

  setCommitting(false);
}

        const warningLists=()=>{
          setIsOpen(!isOpen);
          scrollContainer(!isOpen)
        }
  const sectorSearchModal=async()=>{
setState((prev)=>({...prev,selected:{action:"findSectors"}}))
  }

const commitInstance=()=>{
  setModalTitle('Commit Instance -' +editorInstance?.name );
  updatedEditFields = [
    {
        label: 'Committing an instance is irreversible. Make sure that everything is in order before proceeding.',
        attribute: 'alertMessage', type: 'alertMessage'
    }
];
setModalCustomButtons([
 {
   label: committing ? 'Committing...' : 'Proceed',
   attribute:'button',
   type:"button",
   disabled: committing,
   className:'submit-button',
   action:(state)=>onEnableDisableAction(state)
 }
]);

setState( (_prev) => {
  return { ..._prev,selected: {instance,action: 'commitInstance' }}
   });
setEditFieldsCess(updatedEditFields);
}


const upliftCreate = async (e, sectDetails) => {
 
  const {
    originName,
    flightNumber,
    destinationName,
    id,
    flightDate,
    key,
    uplifts
  } = sectDetails;
  setLoading(true);
  let wId = null;
  let sId = null;

  try {
    if (uplifts?.length) {
      wId = uplifts[0]?.warehouse?.warehouseId;
    } 
    
const respWarehouse = await fetchWarehouses();

if (!wId && respWarehouse.length > 1) {
  const warehouse = respWarehouse.find(wh =>
    wh.label.includes(originName)
  );
  wId = warehouse?.value || null;
}

if (wId && respWarehouse.length > 1) {
  const respSectors = await fetchSectors(wId);

  if (respSectors?.length > 1) {
    const targetSector = `${flightNumber}(${originName}-${destinationName})`.replace(/\s/g, "");

    const sector = respSectors.find(
      opt => opt.label.replace(/\s/g, "") === targetSector
    );

    sId = sector?.value || null;
  }
}

    setState(prev => ({
      ...prev,
      selected: {
        action: "createUplift",
        key,
        sectorId: id,
        fltDate: flightDate,
        warehouse: wId,
        sector: sId,
        flightDate: new Date(flightDate)
      }
    }));

  } catch (err) {
    console.error("Error in upliftCreate:", err);
  }finally{
    setLoading(false);
  }
};

const fetchWarehouses = async () => {
  if(optionsWarehouse.length>1) return optionsWarehouse;
  try {
    const resp = await APIEndpoint.get('warehouses');

    if (resp.result.length > 0) {
      const options = [
        { key: 0, label: 'Select Warehouse', value: '' },
        ...resp.result.map(fieldValue => ({
          key: fieldValue.id,
          label: fieldValue.value,
          value: fieldValue.id
        }))
      ];

      setOptionsWarehouse(options);
      return options; 
    } else {
      return [];
    }
  } catch (error) {
    console.error("Warehouse fetch error:", error);
    return [];
  }
};

const fetchSectors = async (id) => {
  if (!id) return [];
  if(optionsSector.length>1) return optionsSector;

  try {
    const resp = await APIEndpoint.get(`warehouses/sectors/${id}`);

    let options = [{ key: 0, label: 'Select Sector', value: '' }];

    if (resp.result.length > 0) {
      options = [
        ...options,
        ...resp.result.map(fieldValue => ({
          key: fieldValue.storeId,
          label: `${fieldValue.flightNumber} (${fieldValue.originName} - ${fieldValue.destinationName})`,
          value: fieldValue.storeId
        }))
      ];

      setOptionsSector(options);
      return options;
    }

    return options;
  } catch (error) {
    return [];
  }
};


const sectorEditDetails={
 loading,setLoading,editorInstance,eventLogs,delOffld, dfpCommit, inventoryDetails,navigateInstanceId,setNavigateInstanceId,saveEdits,setActionStatus,setEditedSectors,id,setEditAction,editAction,editDetails,upliftCreate,createUplifts
}
const fetchComitState=()=>{
  if(!state.selected)return;
  return true
}
const handleIgnoreCheck=()=>{
  setState( (_prev) => {
    return { ..._prev,ignoreWarningCheck:!state.ignoreWarningCheck}

     });
}
  const handleModalCancelEvent=(act=null)=>{

    setState((prev)=>({...prev,selected:false}))
    setModalFormStatusObj({ text: '' })
    setFilterSectors(false);
    setSectors([]);
    setEmployee([]);
    setFilghts("");
    if(act==='findSector')
    setActionStatus({action:'Find Sector',status:'Operation cancelled by user'})
    setPage(1);
   }

 
  return (<>
   { !editorInstance ?
          <Loading />: <div ref={containerRef} className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark" style={{overflowY:'scroll'}}>
      <div className='flexRow justifyContentSpaceBetween' style={{margin:'0rem 0.5rem'}}>

        <div className="flexRow justifyContentFlexStart alignItemsBaseline">
        { editorInstance.state==='open'&& !dfpCommit ?<> 
     
          </>:editorInstance && editorInstance.id && !loadingEditSectors && editorInstance.state !=='open' ?<button onClick={()=>fetchEditDocument("touch")} disabled={editorInstance&&(editorInstance.state==='open'||editorInstance.state==='committed')?true:false} className={editorInstance&&(editorInstance.state==='open'||editorInstance.state==='committed')?"isolate-cont-control-opaque margRight10":"isolate-cont-control margRight10"}>
          <span style={{ verticalAlign: 'baseline',marginBottom:0 }}><IoReloadCircleSharp style={{marginRight:'5px'}}/>Touch</span>
             </button>:null}
            {editorInstance && editorInstance.id && !loadingEditSectors?<><button onClick={sectorSearchModal} disabled={editorInstance&&(editorInstance.state==='open'||editorInstance.state==='committed')?true:false}  className={editorInstance&&(editorInstance.state==='open'||editorInstance.state==='committed')?"isolate-cont-control-opaque margRight10":"isolate-cont-control margRight10"}>
             <span style={{ verticalAlign: 'baseline' }} >  <FaSearch style={{marginRight:'5px'}}/>  Find Sector</span>
             </button>
            
             <button onClick={commitInstance} disabled={editorInstance&&(editorInstance.state==='open'||editorInstance.state==='committed')?true:false}  className={editorInstance&&(editorInstance.state==='open'||editorInstance.state==='committed')?"isolate-cont-commit-opaque margRight10":"isolate-cont-commit margRight10"}>
             <span style={{ verticalAlign: 'baseline' }} >   <FaLock style={{marginRight:'5px'}} /> Commit</span>
             </button></>:<> <img src={LoadingIn}  className="loading-img" alt="Loading" /></>}
             </div>

<div className='flexRow justifyContentFlexEnd'>

{actionStatus.status?<div className="editContainer-same" style={{whiteSpace:'nowrap',minWidth:"160px",maxWidth:'540px',marginRight:"5px",borderRadius:'5px'}}  >
<div className='flexRow status-bar-flag' style={{borderBottom:'0px'}}>
  { actionStatus.action} : {actionStatus.status}
</div>

</div>:<></>}

  {editDetails.validationResult?.documentErrors.length?<button ref={flagItem} className="grid-download-btnStyle1" onClick={()=>warningLists()}>
    <span className="">
    <FaFlag style={{color:editDetails.validationResult?.documentErrors.length?'#f03630':'white'}} />
                                            </span>


    </button>:<></>}

</div>
      </div>



      {isOpen?<>
        <div className="flexCol chat-popup margRight margTop5"  style={{height: '55%',maxHeight: 'calc(100vh - 50px)', overflow: 'hidden' }}>
    <div className='flexRow status-bar-flag justifyContentSpaceBetween'>
      <div className='justifyContentFlexStart alignItemsCenter'>
      <FaFlag  size={16} style={{marginTop:'8px',color:'#f03630'}}/>
    </div>
    <div className='justifyContentFlexEnd flexRow alignItemsCenter justifyContentCenter'>
  <span className='margRight10'> Errors</span> <span style={{marginRight:0,backgroundColor:'#f03630',borderColor:'#f03630',color:'white'}} className="round-border-count">{editDetails.validationResult?.documentErrors.filter(er=>er.level==='error').length}</span>
  <span className='margLeft6 margRight10'>Warnings </span> <span style={{marginRight:0,backgroundColor:'#e7db76',borderColor:'#e7db76',color:'#595422'}} className="round-border-count">{editDetails.validationResult?.documentErrors.filter(er=>er.level==='warning').length}</span>
    </div>
</div>
<div class="form-container">
  <ul className='list-group' style={{ listStyleType: 'disc', height: '40vh',overflowY: 'scroll' }}>
    {editDetails.validationResult?.documentErrors.map((errDet,index) => (
      <li key={index} className={errDet.level==='warning'?'error-det-isolates-mild':'error-det-isolates-heavy'}>
        <p>{errDet.message}</p>
        <p>Resolutions:</p>
              <ul className='margBottom10'>
              {errDet.resolutions.map(resl => (
              <li key={resl.id} className='margBottom10 flexRow justifyContentFlexStart'>
              &bull;&nbsp;{resl}
              </li>
              ))}
              </ul>
      </li>
    ))}
  </ul>
</div>
</div>
</>:<></>}

{loadingEditSectors && editorInstance && editorInstance.state!=='committed' && editorInstance.state!=='open' ? (
  <div className='flexRow justifyContentCenter alignItemsCenter margTop36'>
    <img src={LoadingIn} className="loading-img" alt="Loading" />
    <div className="margTop5">Please wait while we fetch necessary details. This might take a while...</div>
  </div>
) : editDetails.sectors && editDetails.sectors.length ? (
  <div className="editContainer-same" style={{borderRadius: '5px', margin: '2rem 0.5rem' }}>
    <div className='flexRow status-bar-flag'>
      <div className='justifyContentFlexStart'>Sectors</div>
    </div>
    <SectorsEditIsolate setSort={setSorting}sortingSector={sorting} {...sectorEditDetails} header={editDetails.sectors} deleteRefresh={fetchEditDocument} />
  </div>
) : (  editorInstance && editorInstance.state==='committed'?  <div class="alert alert-success margTop10">Instance has been committed.</div>:<>
        { editorInstance && editorInstance.state==='open'? 
null
          :<>
         <div className="editContainer-same" style={{ borderRadius: '5px', margin: '2rem 0.5rem' }}>
  <div className='flexRow status-bar-flag'>
    <div className='justifyContentFlexStart'>Sectors</div>
  </div>
  <li className='flexRow'>
    <div  style={{margin:'1rem'}}className='flexRow col-xs-11 wrapper-sector justifyContentCenter alignItemsCenter'>
      No sectors attached to this instance yet.
    </div>
  </li>
</div>
         </>
      }

</>




)}


{editDetails.sectors && editDetails.sectors.length?<div className="editContainer-same margTop16"  style={{width:'50%', borderRadius:'5px',margin:'2rem 0.5rem' }}>

    <div className='flexRow status-bar-flag'>
      <div className='justifyContentFlexStart'>
       Preview
    </div>

</div>
<div className="flexRow">
<div className="width90 textAlignCenter alert alert-success margTop10">No Preview Available.</div>
</div>

</div>:<></>}





       {
       state&&state.selected&&state.selected.action === 'findSectors' &&<div className='full-flex width100'> <Modal
        className=''
        title={`Find Sector`}
        onSubmit={handleModalCancelEvent}
        onClose={()=>handleModalCancelEvent("findSector")}
        modalFormStatusObj={modalFormStatusObj}
        >
     <SectorListing stores={stores} employees={employees} {...sectorDetails} attachSector={attachSector} sectorListing={sectorListing} loadSectorListing={loadSectorListing}/>

      </Modal></div>

      }


 
      {
         Boolean(state?.selected) && (state?.selected?.action==='commitInstance') && fetchComitState() ? (
        <div className='flexRow width100'>
          <EditModal
            key={state.selected.action}
            title={ modalTitle }
            onClose={onClose}
            mainContentCenter={true}
            modalFormStatusObj={modalFormStatusObj}
            onSubmit={onEnableDisableAction}
            modalCustomButtons={modalCustomButtons}
            fields={EditFieldsCess.map( (elt) => {
              return { ...elt, initialValue: state.selected.instance[elt.attribute] }
              })
            }
          />
          </div>
        )
        : null
      }

{
         Boolean(state?.selected) && (state?.selected?.action==='forceCommit' ||state?.selected?.action==='noForceCommit') ? (

        <div className='full-flex width100'>
        <Modal
        className=''
        title={modalTitle}
        key={state.selected.action}
        onSubmit={onEnableDisableAction}
        onClose={onClose}
        modalFormStatusObj={modalFormStatusObj}
        modalCustomButtons={[
          {
            label: 'Proceed',
            attribute: 'button',
            type: "button",
            disabled: !state.ignoreWarningCheck,
            className: 'submit-button',
            action: (state)=>onEnableDisableAction(state)
          }
        ]}
        >
       <>
       <p  style={{margin:0,width:'98.5%'}}className='dialog__alertMessage' dangerouslySetInnerHTML={ {__html:'Committing an instance is irreversible. Make sure that everything is in order before proceeding.'}}></p>
       <ul className='list-group' style={{ listStyleType: 'disc', maxHeight: '47vh', overflowY: 'scroll' }}>
         {state.selected.dataWarnings?.map((errDet, index) => (
        <li key={index} className={errDet.level === 'warning' ? 'error-det-isolates-mild' : 'error-det-isolates-heavy'}>
            <p>{errDet.message}</p>
             <p>Resolutions:</p>
              <ul className='margBottom10'>
              {errDet.resolutions.map(resl => (
              <li key={resl.id} className='margBottom10 flexRow justifyContentFlexStart'>
              &bull;&nbsp;{resl}
              </li>
              ))}
              </ul>
        </li>
  ))}
</ul>
<>
     {state?.selected?.action!=='noForceCommit' ?<div className={`dialog__container_item input-container`}>
            <div className={`dialog__description__checkbox `}>
              <input
                  id='2'
                  type={'checkbox'}
                  onClick={handleIgnoreCheck}
                  checked={state.ignoreWarningCheck}
                  value={state.ignoreWarningCheck}
                  required={true}
                />
                <label htmlFor='2' className='margTop8'>Ignore warnings</label>
            </div>
        </div>:<></>}
        </>
</>


      </Modal></div>

        )
        : null
      }
          {

    state && (state.selected?.action === 'createUplift') && createUplifts ? <div className='full-flex width100'>
    <EditModal
    disabled={buttonStatus}
    key={state.selected.action}
    title={`Create Uplift - ${state.selected.key}`}
    onClose={onCloseModal}
    onSubmit={onEditSubmit}
    setIsDropdownOpen={setIsDropdownOpen}
    customContentHeight={ModalContHeight}
    modalFormStatusObj={modalFormStatusObj}
    showDone={true}
    buttonLabel={'Continue'}
    onChange = {onFieldChangeHandler}
    showFieldsInColumn={true}
    fields={
    AddFormFields.map( (elt) => {
    return {...elt, value: state.selected[elt.attribute]}
    })

    }
    /></div>:null}

      </div>}



</>
  )
}